// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { StatusItems } from '../../SagaStateLib/StatusItems';
import * as SagaStateLib from '../../SagaStateLib';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListResourceStatus_abstract extends StatusItems {
  static $t: string = 'SagaStateLib.ListResourceStatus';
  $t: string = 'SagaStateLib.ListResourceStatus';

  public static GetMembers(): string[] {
    return ['MobileFlags'].concat(StatusItems.GetMembers());
  }

  public GetMembers(): string[] {
    return ListResourceStatus_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public MobileFlags: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
